import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary';
  href?: string;
  target?: string;
  rel?: string;
  onLinkClick?: () => void;
  showIcon?: boolean;
}
const variantClasses: Record<'primary' | 'secondary', string> = {
  primary: 'text-white bg-cta hover:bg-cta-hover shadow-lg shadow-cta/30 border-2 border-cta hover:border-cta-hover',
  secondary: 'text-ink bg-white hover:bg-mist shadow-sm border-2 border-ink'
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  href,
  target,
  rel,
  onLinkClick,
  showIcon = true,
  ...props
}: ButtonProps) {
  const baseClasses = `inline-flex items-center justify-center gap-3 px-8 py-4 text-lg font-display font-extrabold uppercase tracking-wide rounded-xl transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cta focus-visible:ring-offset-2 ${variantClasses[variant]}`;
  const content = <>
      <span data-id="element-61" data-mp="hz8mf45604jp">{children}</span>
      {showIcon && variant === 'primary' && <ArrowRight className="w-[1.1em] h-[1.1em] shrink-0" aria-hidden="true" data-id="element-62" data-mp="3cfckeeezqyw" />}
    </>;
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={`${baseClasses} ${className}`} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.97
    }} transition={{
      duration: 0.12,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-63" data-mp="895ul79s4wmy">
        {content}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} transition={{
    duration: 0.12,
    ease: [0.23, 1, 0.32, 1]
  }} {...props} data-id="element-64" data-mp="3ljczv5o9pgzp">
      {content}
    </motion.button>;
}